import { useEffect, useState } from 'react';

export const DelayedRender = ({
  delay,
  children,
  fallback,
}: {
  delay: number;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) => {
  const [hasWaitedLongEnough, setHasWaitedLongEnough] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHasWaitedLongEnough(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!hasWaitedLongEnough) {
    return fallback ?? null;
  }

  return <>{children}</>;
};
